import { InfoFeedbackScreen, ButtonPrimary, ErrorFeedbackScreen } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const EnableSharedDataMessage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const isEnabled = () => {
        return state?.enable ? (
            <div className='enableSharedDataMessage-page__info'>
                <InfoFeedbackScreen
                    title={t('enableSharedDataInfoFeedbackTitle')}
                    description={t('enableSharedDataInfoFeedbackDescriptionActivate')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                navigate('/home');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                />
            </div>
        ) : (
            <div className='enableSharedDataMessage-page__info'>
                <InfoFeedbackScreen
                    title={t('enableSharedDataInfoFeedbackTitle')}
                    description={t('enableSharedDataInfoFeedbackDescriptionDeactivate')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                navigate('/home');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                />
            </div>
        );
    };

    const isNotEnabled = () => {
        return state?.enable ? (
            <div className='enableSharedDataMessage-page__error'>
                <ErrorFeedbackScreen
                    title={t('enableSharedDataErrorFeedbackTitleDeactivate')}
                    description={t('enableSharedDataErrorFeedbackDescriptionDeactivate')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                navigate('/home');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                    errorReference={t('feedbackCodeError') + ` ${state?.error}`}
                />
            </div>
        ) : (
            <div className='enableSharedDataMessage-page__error'>
                <ErrorFeedbackScreen
                    title={t('enableSharedDataErrorFeedbackTitleActivate')}
                    description={t('enableSharedDataErrorFeedbackDescriptionActivate')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                navigate('/home');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                    errorReference={t('feedbackCodeError') + ` ${state?.error}`}
                />
            </div>
        );
    };

    return <div className='enableSharedDataMessage-page'>{state?.success ? isEnabled() : isNotEnabled()}</div>;
};

export default EnableSharedDataMessage;
